import request from "../request";

const app = {
  create: function () {
    const obj = {};
    // 获取App数据
    obj.info = function (data) {
      return request({
        url: "/app/info",
        method: "get",
        params: data
      });
    };
    // 获取App列表
    obj.list = function (data) {
      return request({
        url: "/app/list",
        method: "get",
        params: data
      });
    };
    // 保存App数据
    obj.save = function (data) {
      return request({
        url: "/app/save",
        method: "get",
        params: data
      });
    };
    // 获取App版本列表
    obj.version = function (data) {
      return request({
        url: "/app/version",
        method: "get",
        params: data
      });
    };
    // 获取App广告位列表
    obj.loc = function (data) {
      return request({
        url: "/app/loc",
        method: "get",
        params: data
      });
    };
    // 获取App渠道列表
    obj.chn = function (data) {
      return request({
        url: "/app/chn",
        method: "get",
        params: data
      });
    };
    // 获取App地区列表
    obj.area = function (data) {
      return request({
        url: "/app/area",
        method: "get",
        params: data
      });
    };
    // 上传游戏图标
    obj.uploadImage = function (data) {
      return request({
        url: '/upload/image/save',
        method: 'post',
        data: data
      })
    }
    return obj;
  }
}.create();
export default app;



// WEBPACK FOOTER //
// ./src/api/system/app.js